import { Link } from "react-router-dom";

export default function LegalFooter() {
  return (
    <footer className="border-t border-border bg-background py-6 px-6 mt-12">
      <div className="max-w-3xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
        <p>© {new Date().getFullYear()} Comms Fusion Pro. All rights reserved.</p>
        <nav className="flex gap-4">
          <Link to="/privacy" className="hover:text-foreground transition-colors">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-foreground transition-colors">Terms of Service</Link>
          <Link to="/data-collection" className="hover:text-foreground transition-colors">Data Collection</Link>
        </nav>
      </div>
    </footer>
  );
}
